export { Paragraph } from './Paragraph';
export { SmallParagraph } from './SmallParagraph';
export * from './types';
